import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes';
import type {ClearIndicatorProps, GroupBase} from 'chakra-react-select';
import {chakraComponents} from 'chakra-react-select';

import {SelectIcon} from './SelectIcon';

export const ClearIndicator = <Option, IsMulti extends boolean, Group extends GroupBase<Option>>(
  props: ClearIndicatorProps<Option, IsMulti, Group>,
) => {
  return (
    <chakraComponents.ClearIndicator {...props}>
      {/* // TODO: check fontSize is not provided by theme */}
      <SelectIcon fontSize={`md`} icon={faTimes} />
    </chakraComponents.ClearIndicator>
  );
};
